import {store} from 'Store/store.index';
import { loginApis, isPathMatchValidPage, isNeedAutoSignIn, isAvoidAutoSignIn} from 'Api/index';
import { ROUTE_PATH_FEEDBACK} from 'Api/constants';
import { BROWSER_REMOVE_TICKET, BROWSER_HOME_PAGE, BROWSER_REMOVE_FOR_SSO, BROWSER_REMOVE_FOR_OFFICE_ADD_IN} from '../constants';
import {getQueryVariable} from 'Utils/utils'

export default class BrowserService {
  removeTicket = () => {
    let value = loginApis.getHostUrlWithoutTicket();
    let params = {
      pathname: value.pathname,
      search: value.search,
    };
    store.historyStore.push(params);
  };
  removeForSSO = () => {
    let value = loginApis.getHostUrlForSSO()
    let params = {
      pathname: value.pathname,
      search: value.search,
    };

    store.historyStore.push(params);
  }
  removeForOfficeAddIn = () => {
    let value = loginApis.getHostUrlForOfficeAddIn()
    let params = {
      pathname: value.pathname,
      search: value.search,
    };

    store.historyStore.push(params);
  }
  doSwitchViewPageBy = (key) => {
    switch (key) {
      case BROWSER_HOME_PAGE:{
        store.historyStore.push({pathname:'/', search:''});
        break;
      }
      case BROWSER_REMOVE_TICKET:
        this.removeTicket();
        break;
      case BROWSER_REMOVE_FOR_SSO:
        this.removeForSSO();
        break;
      case BROWSER_REMOVE_FOR_OFFICE_ADD_IN:
        this.removeForOfficeAddIn();
        break
      default:
        break;
    }
  };

  isNeedAutoSignIn = (path) =>{
    return isNeedAutoSignIn(path);
  }


  isAvoidAutoSignIn = (path) =>{
    let server_config = getQueryVariable('server_config');
    if(server_config){
      return true;
    }
    let useLocalAiPlugin = getQueryVariable('ai_plugin');
    if(!!useLocalAiPlugin){
      return true;
    }
    return isAvoidAutoSignIn(path);
  }

  isValidRoutePath = (path) =>{
    if(!path)path = '/';
    if(path === ROUTE_PATH_FEEDBACK && !store.userStore.hasSignIn){
      return false;
    }
    let value = isPathMatchValidPage(path);
    return value;
  }
  doGoToHomePage = ()=>{
      this.doSwitchViewPageBy(BROWSER_HOME_PAGE);
  }
}
